
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,HttpEvent } from '@angular/common/http';
import {environment} from '../../environments/environment';
import { from, Observable } from 'rxjs'; 
@Injectable({
  providedIn: 'root'
})
export class DownloaderService {
  
  constructor(private http:HttpClient) { }

  verify(id)
  {
    console.log("bout to verify to backend");
    
    const server =  environment.BACK_CONSULTA+id;
    return this.http.get(server)
   //ged-backend-cloud-master/novedades
  }

  download(target): Observable<HttpEvent<any>>
  {
    const server =  environment.BACK_DOWNLOADER;
    return this.http.post(server,target, { responseType: 'blob',reportProgress: true, observe: "events" } )
    
  }

  getVideoURL(bucket,id_s3)
  {
    console.log("gettin url video");
    let params="?bucket_name="+bucket+"&id_s3="+id_s3
    const server =  environment.BACK_VIDEO_URL+params;
    return this.http.get(server)
   //ged-backend-cloud-master/novedades
  }
}
